export const toClassName = (...values: (boolean | string | undefined)[]) => {
  return values.filter(Boolean).join(' ');
};

export const handleGenerateInitialsFromName = (name: string) => {
  let result = name;

  if (name) {
    result = name.charAt(0);
  }

  return result;
};

export const handleFormatDate = (date: string, t: any) => {
  const dateObject = new Date(date);
  return `${dateObject.getDate()} ${t(`enum.date.month.${dateObject.getMonth()}`)} ${dateObject.getFullYear()}`;
};

export const handleConvertToLocale = (lang: string) => {
  let result = lang;

  switch (lang) {
    case 'nl':
      result = 'nl-BE';
      break;
    case 'fr':
      result = 'fr-BE';
      break;
    case 'en':
      result = 'en';
      break;
  }

  return result;
};

export const formatDateToStringToCat = (dateObj: Date, t: any) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return '';

  const days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

  return `${t(`enum.day.${days[dateObj.getDay()]}`)} ${String(dateObj.getDate()).padStart(2, '0')}.${String(
    dateObj.getMonth() + 1,
  ).padStart(2, '0')}`;
};

export const convertDateToHHmm = (dateObj: Date) => {
  if (!(dateObj instanceof Date) || isNaN(dateObj as any)) {
    console.error('Invalid input: Please provide a valid Date object.');
    return '';
  }

  // Correct for timezone issues.
  const newDate = new Date(dateObj.getTime());
  const timeZoneCorrection = 2;
  newDate.setTime(newDate.getTime() + timeZoneCorrection * 60 * 60 * 1000);

  const hours = `0${newDate.getHours()}`.slice(-2);
  const minutes = `0${newDate.getMinutes()}`.slice(-2);

  return `${hours}:${minutes}`;
};
